var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.1425 2H5.8575C3.1275 2 1.5 3.6275 1.5 6.3575V12.635C1.5 15.3725 3.1275 17 5.8575 17H12.135C14.865 17 16.4925 15.3725 16.4925 12.6425V6.3575C16.5 3.6275 14.8725 2 12.1425 2Z",
    fill: "#D6EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.875H4.5C4.1925 6.875 3.9375 6.62 3.9375 6.3125C3.9375 6.005 4.1925 5.75 4.5 5.75H13.5C13.8075 5.75 14.0625 6.005 14.0625 6.3125C14.0625 6.62 13.8075 6.875 13.5 6.875Z",
    fill: "#D6EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.0625H6C5.6925 10.0625 5.4375 9.8075 5.4375 9.5C5.4375 9.1925 5.6925 8.9375 6 8.9375H12C12.3075 8.9375 12.5625 9.1925 12.5625 9.5C12.5625 9.8075 12.3075 10.0625 12 10.0625Z",
    fill: "#D6EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99749 13.25H7.99499C7.6875 13.25 7.4325 12.995 7.4325 12.6875C7.4325 12.38 7.6875 12.125 7.99499 12.125H9.99749C10.305 12.125 10.56 12.38 10.56 12.6875C10.56 12.995 10.3125 13.25 9.99749 13.25Z",
    fill: "#D6EDFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.3aa4b86e4d1031e26d235f62a2778e46.svg";
export { ForwardRef as ReactComponent };